(function($) {
    $(document).ready(function() {
        $('.back-button').click(function() {
            var url = document.referrer == window.location.href ? '/' : document.referrer;
            window.location.href = url;
        });
    });
})(jQuery);
